import RouterLink from "./router-link";

export default function ButtonBase(props) {
    return (
        <RouterLink href={props.link} {...props}>{props.children}</RouterLink>
    )
}
